import { render, staticRenderFns } from "./PricePeriodTopAlerts.vue?vue&type=template&id=5d9b6780&"
import script from "./PricePeriodTopAlerts.vue?vue&type=script&lang=js&"
export * from "./PricePeriodTopAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
